import type { FloraDossierDocument } from '../../types/flora-ai.types';
import { FloraDocumentSkeleton } from '../FloraDocumentSkeleton/FloraDocumentSkeleton';
import styles from './FloraDossierCard.module.css';

interface FloraDossierCardProps {
	document: FloraDossierDocument;
}

export const FloraDossierCard = ({ document }: FloraDossierCardProps) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.card}>
				<div className={styles.tab} />
				<div className={styles.sheet}>
					<div className={styles.preview}>
						<FloraDocumentSkeleton lineCount={6} />
					</div>
					<p className={styles.name}>{document.name}</p>
					<p className={styles.pages}>{document.pages} páginas</p>
				</div>
			</div>
		</div>
	);
};
